import React from 'react';
import {Table} from '../../globals/state';
import {CONFIG, I18N} from '../../globals/config';
import {formatCounted} from '../../helpers/format';

import styles from './status.pcss';

type Props = Table & {}

const Status = ( {status, count, checked}: Props ) => {
	// UGH! Use HTML markup to solve a strange bug in IE11 :-(.
	const loading = ` <img src="${CONFIG.loading}" alt="${I18N.searching}" />`;

	const getStatus = () => {
		//phpcs:disable WordPressVIPMinimum.JS.DangerouslySetInnerHTML
		switch ( status ) {
			case 'counted':
				return <div
					dangerouslySetInnerHTML={{__html: formatCounted( I18N.willUpdate, count )}} />;
			case 'counting':
				return <div
					dangerouslySetInnerHTML={{__html: I18N.searching + loading}} />;
			case 'failed':
				return <div>{I18N.failed}</div>;
			case 'untouched':
				return <div>{I18N.safeToUpdate}</div>;
			case 'updated':
				return <div
					dangerouslySetInnerHTML={{__html: formatCounted( I18N.updated, count )}} />;
			case 'updating':
				return <div
					dangerouslySetInnerHTML={{__html: I18N.updating + loading}} />;
		}
	};

	if ( ! checked ) {
		return null;
	}

	return (
		<div className={styles.wrap + ' ' + styles[ status ]}>
			{getStatus()}
		</div>
	);
};

export default Status;
